import './DataDictionaryTable.scss';
import './SharedDataDictionaryTable.scss';
import { PaginatedTable } from '@ui/tables';
import { PaginationDirection } from '@sonar-software/sonar-ts-types';
import { SearchInput } from '@ui/general';
import { SonarText } from '@ui/text';
import { SortedBySelect } from '@ui/table-modifier/SortedBy';
import { Space } from 'antd';
import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { getAppliedOrdering, parseMetadataFromResponse, translateFilterAndOrderingToQueryParams, translateOrderQueryParamsToDynamicQueryLanguage } from '@ui/table-modifier/@arch/lib';
import React, { useCallback, useMemo } from 'react';
const rowKey = (entry) => entry.sonarObjectId;
export const SharedDataDictionaryTable = ({ loading, resource, updateQuery }) => {
    const { schema, sortOptions } = useMemo(() => {
        var _a;
        const results = parseMetadataFromResponse(resource === null || resource === void 0 ? void 0 : resource.schema, () => true, atob((_a = resource === null || resource === void 0 ? void 0 : resource.appliedColumns) !== null && _a !== void 0 ? _a : ''));
        return {
            schema: results.schema,
            sortOptions: results.sortOptions
        };
    }, [resource]);
    const sortQueryParams = useMemo(() => {
        var _a;
        return translateFilterAndOrderingToQueryParams([], sortOptions, '', getAppliedOrdering((_a = resource === null || resource === void 0 ? void 0 : resource.appliedOrderingAndFilters) !== null && _a !== void 0 ? _a : ''));
    }, [resource === null || resource === void 0 ? void 0 : resource.appliedOrderingAndFilters, sortOptions]);
    const header = resource ? `${resource.organizationName} - ${resource.viewName}` : '';
    const handleSortUpdate = useCallback((update) => {
        updateQuery({
            key: '',
            ordering: translateOrderQueryParamsToDynamicQueryLanguage(update),
            paginationDirection: PaginationDirection.Forward
        });
    }, [updateQuery]);
    const handleFilterByName = useCallback((name) => {
        updateQuery({
            filterByName: name
        });
    }, [updateQuery]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Space, { className: 'shared-view-header' },
            React.createElement(SonarText, { size: 16, weight: 'semibold' }, header),
            resource &&
                React.createElement(SortedBySelect, { defaultValue: sortQueryParams.sortDefault || sortOptions[0], onChange: handleSortUpdate, queryParams: sortQueryParams, sortOptions: sortOptions })),
        React.createElement(SearchInput, { className: 'filter-by-name', id: 'filterByName', onChange: handleFilterByName, placeholder: PLACEHOLDERS_COPY.FILTER_BY(COPY_SPECIFIC.NAME) }),
        React.createElement(PaginatedTable, { className: 'data-dictionary-table shared-data-dictionary-table no-click', columns: schema, defaultPageSize: 10, loading: loading, onChange: updateQuery, resource: resource, rowKey: rowKey, scroll: {
                scrollToFirstRowOnChange: true,
                x: (resource === null || resource === void 0 ? void 0 : resource.results.length) ? 'max-content' : 4000
            } })));
};
